import React from 'react';
import 'emoji-mart/css/emoji-mart.css';
import GeneralDialog from '../GeneralDialog';
import { Picker } from 'emoji-mart';
import styled from 'styled-components/macro';

const EmojiDialog = styled(GeneralDialog)`
  [class*='MuiDialogContent-root'] {
    padding: 0 !important;
  }
  .emoji-mart {
    border: 0 none !important;
    display: block !important;
  }
  .emoji-mart-category .emoji-mart-emoji:hover:before {
    left: 4px;
    top: 3px;
  }
  .emoji-mart-preview {
    display: none !important;
  }

  .emoji-mart .emoji-mart-emoji {
    padding: 8px !important;
  }

  .action-buttons-wrapper {
    display: none;
  }
`;

const EmojiInserterView = ({
  clickedEmoji,
  showEmojiDialog,
  setShowEmojiDialog
}) => {
  return (
    <EmojiDialog
      buttons={[]}
      open={showEmojiDialog}
      handleClose={() => setShowEmojiDialog(false)}
      handleConfirm={() => setShowEmojiDialog(false)}
      noX
    >
      <Picker set='google' onSelect={clickedEmoji} native/>
    </EmojiDialog>
  );
};

export default EmojiInserterView;